import { createSvgIcon } from '@automata/mui-theme';
export const DisposeIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path d="M37.5 36H40.5V65H37.5V36Z" />
    <path d="M46.5 36H49.5V65H46.5V36Z" />
    <path d="M55.5 36H58.5V65H55.5V36Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29 28V73C29 73.5523 29.4477 74 30 74H66C66.5523 74 67 73.5523 67 73V28H29ZM28 25C26.8954 25 26 25.8954 26 27V73C26 75.2091 27.7909 77 30 77H66C68.2091 77 70 75.2091 70 73V27C70 25.8954 69.1046 25 68 25H28Z"
    />
    <path d="M22 25H74V28H22V25Z" />
    <path d="M38 19H59V22H38V19Z" />
    <path d="M38 20H41V25H38V20Z" />
    <path d="M56 20H59V25H56V20Z" />
  </svg>,
  'DisposeIcon'
);
